module.exports = __webpack_public_path__ + "static/assets/3b0c388c2cf1462401585224ffe2f077.svg";